export default {
    methods: {

        registerWebsockets: function(userId, subUserId, isAdmin, eventCallbackMap) {
            // registra cliente laravel websockets
            window.Echo.channel(`App.User.` + userId)
                .listen('.client-events', (e) => {
                    /*
                     * O evento é executado se:
                     * 1) o usuário logado é root e a flag 'notify_root_user' é true
                     * 2) o usuário logado é sub_user e seu id esteja em 'plugg_sub_user.ids'
                     * 2) o usuário logado é sub_user e a flag 'notify_all_sub_users' é true
                     */
                    if (
                        (!subUserId && e.notify_root_user)
                        || (
                            subUserId
                            && !isAdmin
                            && e.plugg_sub_user_ids.findIndex((x) => x == subUserId) >= 0
                        )
                        || (subUserId && e.notify_all_sub_users)
                    ) {
                        if (eventCallbackMap[e.action]) {
                            eventCallbackMap[e.action](e);
                        }
                    }
                });
        },

    },

};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/pluggSockets.js